import { forwardRef, Ref } from 'react';

import TextFieldBase, { Props as TextFieldBaseProps } from '../TextFieldBase';

export interface Props extends Omit<TextFieldBaseProps, 'inputProps'> {}

const TextField = ({ ...props }: Props, ref: Ref<HTMLDivElement>) => {
  return <TextFieldBase {...props} ref={ref} />;
};

export default forwardRef(TextField);
